import { PartHistory } from '@history/models/part-history.model';
import { SubjectId } from '@master/constants/subject.constant';
import { ViewRouteConfig } from '@scoring-web/configs/route/route.type';
import { lazyWithPreload } from '@ui/utils/lazy.util';

// #region Types
export type AssessmentDetailRouteParams = {
  assessmentId: string;
  versionNumber: string;
};
export type AssessmentDetailRouteState = Partial<
  Pick<PartHistory, 'partNumber' | 'partYear' | 'universityName' | 'universitySubName'> & {
    page: number;
    search: string;
    subjectId: SubjectId;
  }
>;
// #endregion

export const LazyAssessmentDetailView = lazyWithPreload(() => import('./assessment-detail.view'));

const assessmentDetailRoute: ViewRouteConfig = {
  lazy: { Component: async () => LazyAssessmentDetailView },
  path: '/assessments/:assessmentId/:versionNumber',
};

export default assessmentDetailRoute;
